import { render, staticRenderFns } from "./associationNoticeList.vue?vue&type=template&id=3dbe6ab1&scoped=true&"
import script from "./associationNoticeList.vue?vue&type=script&lang=js&"
export * from "./associationNoticeList.vue?vue&type=script&lang=js&"
import style0 from "./associationNoticeList.vue?vue&type=style&index=0&id=3dbe6ab1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbe6ab1",
  null
  
)

export default component.exports